'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Search, _Checkmark;
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className", "selected", "children", "searchKey", "removeCheck", "value", "onSelect"],
  _excluded7 = ["className"];
import * as React from 'react';
import Checkmark from '@crehana/compass.icons.outline/Checkmark';
import Search from '@crehana/compass.icons.outline/Search';
import { CommandLoading as CommandLoadingPrimitive, Command as CommandPrimitive, useCommandState } from 'cmdk';
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Command = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(CommandPrimitive, _objectSpread({
    ref: ref,
    className: cn('tw-rounded tw-overflow-hidden', className)
  }, props));
});
Command.displayName = CommandPrimitive.displayName;
var CommandInput = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center tw-border-solid tw-border-b tw-border-neutral-light-400 dark:tw-border-neutral-dark-500",
    "cmdk-input-wrapper": "",
    children: [_Search || (_Search = /*#__PURE__*/_jsx(Search, {
      size: 24,
      className: "tw-ml-2.4 tw-mr-1.2 tw-shrink-0 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500"
    })), /*#__PURE__*/_jsx(CommandPrimitive.Input, _objectSpread({
      ref: ref,
      className: cn('tw-flex tw-w-full tw-pr-2.4 tw-py-1.2 tw-outline-none tw-font-body4', 'placeholder:tw-text-neutral-light-700 disabled:tw-cursor-not-allowed tw-text-neutral-light-800', 'dark:placeholder:tw-text-neutral-dark-500 dark:tw-text-neutral-light-100', 'tw-bg-transparent', className)
    }, props))]
  });
});
CommandInput.displayName = CommandPrimitive.Input.displayName;
var CommandList = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(CommandPrimitive.List, _objectSpread({
    ref: ref,
    className: cn('tw-max-h-24 tw-overflow-y-auto tw-min-w-[30rem] tw-max-w-[30rem] sm:tw-max-w-[50rem] md:tw-max-w-[80rem] lg:tw-max-w-[100rem]', className)
  }, props));
});
CommandList.displayName = CommandPrimitive.List.displayName;
var CommandEmpty = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsx(CommandPrimitive.Empty, _objectSpread({
    ref: ref,
    className: cn('tw-py-5.6 tw-px-2.4 tw-text-center', className)
  }, props));
});
CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
var CommandGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(CommandPrimitive.Group, _objectSpread({
    ref: ref
  }, props));
});
CommandGroup.displayName = CommandPrimitive.Group.displayName;
var CommandSeparator = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx(CommandPrimitive.Separator, _objectSpread({
    ref: ref,
    className: cn('-mx-1 h-px bg-slate-200 dark:bg-slate-800', className)
  }, props));
});
CommandSeparator.displayName = CommandPrimitive.Separator.displayName;
var CommandItemWithoutRef = function CommandItemWithoutRef(_ref6, ref) {
  var className = _ref6.className,
    selected = _ref6.selected,
    children = _ref6.children,
    searchKey = _ref6.searchKey,
    removeCheck = _ref6.removeCheck,
    value = _ref6.value,
    _onSelect = _ref6.onSelect,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CommandPrimitive.Item, _objectSpread(_objectSpread({
    ref: ref,
    className: cn('tw-group tw-relative tw-flex tw-gap-1.2 tw-w-full tw-justify-between tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-outline-none', 'tw-font-body4 tw-py-1.2 tw-px-2.4 tw-min-h-4.8 dark:tw-text-neutral-light-100', 'data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50', 'aria-selected:tw-bg-neutral-light-300 dark:aria-selected:tw-bg-neutral-dark-600 aria-selected:tw-text-primary-light-500', selected && 'tw-text-primary-light-500', className),
    value: searchKey === null || searchKey === void 0 ? void 0 : searchKey.replace(/\n/g, ' '),
    onSelect: function onSelect() {
      return _onSelect(value);
    }
  }, props), {}, {
    children: [children, !removeCheck && /*#__PURE__*/_jsx("span", {
      className: "tw-flex tw-items-center tw-w-2.4 tw-h-full",
      children: selected && (_Checkmark || (_Checkmark = /*#__PURE__*/_jsx(Checkmark, {
        className: "tw-text-success-400",
        size: 24
      })))
    })]
  }));
};

// Export CommandItem with forwardRef and generic type T
var CommandItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return CommandItemWithoutRef(props, ref);
});
var CommandShortcut = function CommandShortcut(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsx("span", _objectSpread({
    className: cn('ml-auto text-xs tracking-widest text-slate-500 dark:text-slate-400', className)
  }, props));
};
CommandShortcut.displayName = 'CommandShortcut';
export { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandLoadingPrimitive, CommandPrimitive, CommandSeparator, CommandShortcut, useCommandState };